import Vue from 'vue'

import * as service from './addpersonnel.service.js'

function getDefaultData() {
  return {

    //FG - FOOF - After Cert - First Release Security (7) - below
    ViewProfileButtonDependsOn: ['personnelbasicinfo','personneljobinfo','personnelice','personnelmedicalinfo','personnelcertifications','personnelperformance'],
    //FG - FOOF - After Cert - First Release Security (7) - above

    imageurl: baseUrl + 'Documents/ProfilePics/',
    defaultImage: '../../assets/images/Default-avatar.jpg',
    focused: true,
    userrole: '',
    search: '',
    includeinactive: false,
    inactivecount: 0,
    activecount: 0,
    locations: [],
    positions: [],
    locationName: '',
    personellist: [],
    dialogFormVisible: false,
    labelPosition: 'top',
    buttonclicked: false,
    LocationID: '',
    licenceActive: '',
    isdisablebutton: true,
    emittedlocationid: '',
    addPersonal: {
      fname: '',
      lname: '',
      email: '',
      phone: '',
      position: '',
      IsAppUser: false,
      location: ''
    },
    formLabelWidth: '120px',
    rules: {
      fname: [{
          required: true,
          message: 'This field is required'
        },
        {
          min: 1,
          max: 50,
          message: 'Length should be 1 to 50'
        }

      ],
      lname: [{
          required: true,
          message: 'This field is required'
        },
        {
          min: 1,
          max: 50,
          message: 'Length should be 1 to 50'
        }

      ],
      email: [{
          required: true,
          message: 'This field is required',
          trigger: 'blur'
        },
        {
          type: 'email',
          message: 'Invalid Email Address'
        },
        {
          min: 1,
          max: 250,
          message: 'Length should be 1 to 250'
        }

      ],
      phone: [{
        min: 1,
        max: 20,
        message: 'Length should be 1 to 20'
      }],
      position: [{
        required: true,
        message: 'This field is required'
      }],
      location: [{
        required: true,
        message: 'This field is required'
      }]

    }
  }
}
export default {

  data: getDefaultData,
        


  mounted() {
    window.mountindex = 0

    let context = this
    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.LocationID = data.LocationId ? data.LocationId : 0
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      //FG - FOOF - the setTimeout code is from Digiclarity
      setTimeout(function () {
        context.GetPersonnelMinDetailsByLocation(context.LocationID ? context.LocationID : 0)
      }, 100)
    })

    this.$router.app.$on('emittedlocation', (data) => {
      mountindex = mountindex++

        this.emittedlocationid = JSON.parse(data)

      this.GetPersonnelMinDetailsByLocation(JSON.parse(data))


    })

    this.getLocations()



    this.userrole = JSON.parse(this.$localStorage.get('authentication')).role

  },
  computed: {
    filtereddata: function () {


      return this.personellist.filter(function (data) {

        var count = data.FirstName.indexOf(this.search) > -1 || data.Email.indexOf(this.search) > -1 || data.LastName.indexOf(this.search) > -1 //|| data.PhoneNumber.indexOf(this.search) > -1;

        return count

      }.bind(this))

    }
  },
  methods: {
    //FG - FOOF - After Cert - First Release Security (7) - below
    displayViewProfileButton(item) {
      //FG - TRY THIS
      var canDisplay = this.$hydrowareSecurityJS.canDisplay_P(this.ViewProfileButtonDependsOn, item.PersonnelId, item.RoleOrdinanceLow);
      return canDisplay;
   },
    //FG - FOOF - After Cert - First Release Security (7) - above

    //FG - FOOF - After Cert - First Release Security - modified function below to use the employee info
    //     instead of just the id.
    //viewProfile(PersonnelId) {
    viewProfile(employeeInfo) {  
      //store the role ordinance and the employee id of the employee being "viewed" into session
      //storage so it is available for security checks then do the "push" to display the page
      //for that employee.
      
      var employeeBeingViewdId = employeeInfo.PersonnelId
      sessionStorage.setItem('employeeBeingViewed_ordinance', employeeInfo.RoleOrdinanceLow);
      sessionStorage.setItem('employeeBeingViewed_pid', employeeBeingViewdId);
      this.$router.push('/UpdatePersonnel/' + employeeBeingViewdId)
      
    },
    submitForm(formName) {
      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          loader.startLoader()
          context.buttonclicked = false
          var model = {
            FirstName: this.addPersonal.fname,
            LastName: this.addPersonal.lname,
            Email: this.addPersonal.email,
            PhoneNumber: this.addPersonal.phone,
            PositionId: this.addPersonal.position,
            LocationId: this.addPersonal.location,
            IsAppUser: this.addPersonal.IsAppUser
          }
          service.AddPersonnel(model).then(function (response) {

            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {          
              return;
            }


            if (response == '') {
              loader.stopLoader()
              $('.alert').show()
              context.$notify({
                title: 'Success',
                message: 'Succesfully Created Personnel',
                type: 'success'
              })
              $('#Addpersonelmodel').modal('hide')
              context.buttonclicked = true
              if (context.emittedlocationid)
              {

                context.GetPersonnelMinDetailsByLocation(context.emittedlocationid)
              } else {
                context.GetPersonnelMinDetailsByLocation()
              }
            }
          }).catch((error) => {
            var message = error.responseText
            var parsed = JSON.parse(message)
            if (parsed.Message == 'Email already registered.') {//FG --- ??????

            }
            context.$notify.error({
              title: 'Error',
              message: parsed.Message
            })
            context.buttonclicked = true

            loader.stopLoader()
            $('.alert').show()
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'ADD PERSONNEL - error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()

      } else {
        return true
      }
    },
    getLocations() {
      let context = this

      service.GetLocations().then(function (response) {

        context.locations = response

      }, (error) => {

      })

    },
    getposition() {
      let context = this

      service.GetMinPositions().then(function (response) {

        context.positions = response


      }, (error) => {



      })
    },

    showPopup(formName) {

      this.getLocations()
      this.getposition()
      let context = this
      // this.addPersonal = {}
      context.buttonclicked = true

      //this.dialogFormVisible=true;
      setTimeout(function () {
        context.$refs['addPersonal'].resetFields()
      }, 10)
      this.LicenceCheck()

      $('#Addpersonelmodel').modal('show')
      //  $('#myModal').modal('hide');

    },
    handleClose(done) {
      this.dialogFormVisible = false
    },

    LicenceCheck() {
      let context = this


      service.LicenceCheck().then(function (response) {
        context.licenceActive = response

      }).catch((error) => {

      })




    },

    GetPersonnelMinDetailsByLocation(locationid) {
      let context = this
      context.activecount = 0
      context.inactivecount = 0
      loader.startLoader()
      service.GetPersonnelMinDetailsByLocation(locationid).then(function (response) {
        context.activecount = 0
        context.inactivecount = 0
        loader.stopLoader()

        //FG - FOOF - After Cert - First Release Security (7) Can the user at least view the data ?
        if(context.$hydrowareSecurityJS.isDataRestricted(response)) {
          context.personellist = [] 
          return;
        }
        //FG - FOOF - After Cert - First Release Security (7) - above

        context.personellist = response

        for (var i = 0; i < response.length; i++) {

          if (response[i].IsActive) {
            context.activecount = context.activecount + 1
          } else {
            context.inactivecount = context.inactivecount + 1
          }

        }

        $('.alert').show()

      }).catch((error) => {

        var message = error.responseText
        var parsed = JSON.parse(message)
        this.signupError = parsed.Message
        loader.stopLoader()
        $('.alert').show()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/addpersonnel/addpersonnel.controller.js